"use client";

import { useSessionContext } from "@/context/SessionContext";
import { FeatureFlagName } from "@/types/feature-flag";

/**
 * Single read of the Deliverables feature flag. Used both by the sidebar nav
 * entry and by `DeliverablesGate` so the nav and the routes can never disagree.
 */
export const useDeliverablesEnabled = (): boolean => {
  const { getFeatureFlag } = useSessionContext();

  return getFeatureFlag(FeatureFlagName.DELIVERABLES_ENABLED).value === "on";
};
